import { Component, OnInit, Input, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
//import { SimulateurComponent } from 'projects/hp-api/src/lib/simulateur/simulateur.component';
import { SimulateurComponent } from 'projects/hp-api/src/lib/simulateur/simulateur.component';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ModalInfoComponent } from 'projects/hp-api/src/lib/base/modal-info.component';

export class WizardHpBaseComponent implements OnInit {
  @Input() simulateurComponent: SimulateurComponent;

  constructor(private chgDetectorRef: ChangeDetectorRef, 
    private hpService: HpService, 
    private router: Router) {

  }

  ngOnInit(): void {
    this.getHpService().getDataChange().subscribe(value => {
      this.getChangeDetectorRef().markForCheck();
    });

  
  }

  public getHpService() {
    return this.hpService;
  }

  public getRouter() {
    return this.router;
  }

  public getChangeDetectorRef() {
    return this.chgDetectorRef;
  }
  public getChangeDetectorMultiRef() {
    return this.chgDetectorRef;
  }
  public getSimulateur(): SimulateurComponent {
    if (this.simulateurComponent == null) {
      return null;
    } else {
      return this.simulateurComponent;
    }
  }

  public getUrlapi() {
    return this.getHpService().getUrlapi();
  }

  converToHex(valeur: any) {
    if (valeur) {
      let valHex = valeur.toString(16);
      valHex = (valHex.length === 5) ? "0" + valHex : valHex;
      return "#" + valHex;
    }
    return this.getHpService().getAssetsPath() + 'assets/images/0.png';
  }

  update(): void {
    alert('');
  }

  getDisplayImage(item: any) {
    var res = {};
    if (item.image != null && item.image != '' && item.image !== '0') {
      res['background-image'] = 'url(' + this.getUrlapi() + '/fdw/' + item.image + ')';
    } else if (item.visual_color != null && item.visual_color != '' && item.visual_color != '0') {
      res['background-color'] = this.converToHex(item.visual_color);
    } else {
      res['background-image'] = 'url(' + this.getHpService().getAssetsPath() + 'assets/images/0.png' + ')';
    }
    return res;
  }

  getInfosImage(item: any) {
    var res = {};
    if (item.drawimg != null && item.drawimg != '' && item.drawimg !== '0') {
      res['background-image'] = 'url(' + this.getUrlapi() + '/fdw/' + item.drawimg + ')';
    } else if (item.visual_color != null && item.visual_color != '' && item.visual_color != '0') {
      res['background-color'] = this.converToHex(item.visual_color);
    } else {
      res['background-image'] = 'url(' + this.getHpService().getAssetsPath() + 'assets/images/0.png' + ')';
    }
    return res;
  }

  getMiniatureImage(item: any) {
    var res = {};
    if (item.image != null && item.image != '' && item.image !== '0') {
      return this.getUrlapi() + '/fdw/' + item.image ;
    }
    else
    {
      return this.getHpService().getAssetsPath() + 'assets/images/0.png';
    }
  }

  toNextLink() {
    var currentRoute = this.getRouter().url;
    if (currentRoute.startsWith('/')) {
      currentRoute = currentRoute.substring(1);
    }
    if (currentRoute.indexOf('?') > -1) {
      currentRoute = currentRoute.substring(0, currentRoute.indexOf('?'));
    }
    var nextUrl = null;
    if (currentRoute != null && this.getRouter().config != null) {
      var rconfig = this.getRouter().config;
      var cf = null;
      for (var i = 0; i < rconfig.length; i++) {
        cf = rconfig[i];
        if (cf != null && cf.path != null) {
          if (cf.path == currentRoute) {
            nextUrl = rconfig[i + 1].path;
            break;
          }
        }
      }
    }
    if (nextUrl != null) {
      this.toLink(nextUrl);
    }
  }

  toLink(url) {
    this.getRouter().navigate([url]);
  }
  getIndexNextUrl(url: any) {
    const urlIndex = (element) => element.link === url;
    return this.getHpService().getConfig().nav.findIndex(urlIndex);

  }



}
